import {lazy} from 'react';
import IframePageCheck from '@/modules/Iframe';

const QualifyResult = lazy(() => import('@/modules/Result/Result'));
const FaceResult = lazy(() => import('@/modules/Qualify/result'));
const Process = lazy(() => import('@/modules/Result/Process'));
const Agreement = lazy(() => import('@/modules/Qualify/agreement'));
const Confirm = lazy(() => import('@/modules/Qualify/confirm'));
const QualifyIndex = lazy(() => import('@/modules/Index'));
const QualifyList = lazy(() => import('@/modules/List/List'));
const CompanyRemit = lazy(() => import('@/modules/Company/Remit/Remit'));
const PersonFace = lazy(() => import('@/modules/Person/PersonFace'));
const PersonBank = lazy(() => import('@/modules/Person/PersonBank'));
const LegalLiving = lazy(() => import('@/modules/Company/Legal/LegalLiving'));
const Recharge = lazy(() => import('@/modules/Company/Recharge/Recharge'));
const ChangeResult = lazy(() => import('@/modules/Change/ChangeResult'));
const ChangeLogs = lazy(() => import('@/modules/Change/ChangeLog'));
const Change = lazy(() => import('@/modules/Change/Change'));
const ChangeList = lazy(() => import('@/modules/Change/ChangeList'));
const ChangeRegistration = lazy(() => import('@/modules/Company/Change/CompRegister'));
const CompChange = lazy(() => import('@/modules/Company/OrgChange/CompChange'));
const LicenseApply = lazy(() => import('@/modules/License/LicenseApply'));
const LicenseDetail = lazy(() => import('@/modules/License/LicenseDetail'));
const PassSync = lazy(() => import('@/modules/Person/PassSync'));
const PersonDoc = lazy(() => import('@/modules/Person/PersonDoc'));
const ChangeAgreement = lazy(() => import('@/modules/Change/ChangeAgreement'));
const Education = lazy(() => import('@/modules/Person/Education'));
const NoBusinessChange = lazy(() => import('@/modules/Change/NoBusinessChange'));

export const routes = [
    {
        path: '',
        component: QualifyIndex,
        index: true,
    },
    {
        path: 'choices/:type',
        component: QualifyList,
        exact: true,
    },
    {
        path: 'index',
        component: QualifyIndex,
        index: true,
    },
    {
        path: 'result',
        component: QualifyResult,
        exact: true,
    },
    {
        path: 'processing',
        component: Process,
        exact: true,
    },
    {
        path: 'company/remit',
        component: CompanyRemit,
        exact: true,
    },
    {
        path: 'company/legal',
        component: LegalLiving,
        exact: true,
    },
    {
        path: 'company/recharge',
        component: Recharge,
        exact: true,
    },
    {
        path: 'person/face',
        component: PersonFace,
        exact: true,
    },
    {
        path: 'person/bank',
        component: PersonBank,
        exact: true,
    },
    {
        path: 'person/doc',
        component: PersonDoc,
        exact: true,
    },
    {
        path: 'change/list',
        component: ChangeList,
        exact: true,
    },
    {
        path: 'change/:type',
        component: Change,
        exact: true,
    },
    {
        path: 'change/result',
        component: ChangeResult,
        exact: true,
    },
    {
        path: 'change/log',
        component: ChangeLogs,
        exact: true,
    },
    {
        path: 'change/registration',
        component: ChangeRegistration,
        exact: true,
    },
    {
        path: 'change/org/entity',
        component: CompChange,
        exact: true,
    },
    {
        path: 'license/detail',
        component: LicenseDetail,
        exact: true,
    },
    {
        path: 'license/apply',
        component: LicenseApply,
        exact: true,
    },
    {
        path: 'sync',
        component: PassSync,
        exact: true,
    },
    {
        path: 'iframe',
        component: IframePageCheck,
        exact: true,
    },
    {
        path: 'education',
        component: Education,
        exact: true,
    },
    {
        path: 'company/noBusiness/change',
        component: NoBusinessChange,
        exact: true,
    },
];

export const unAuthRoute = [
    {
        path: 'face/result',
        component: FaceResult,
        exact: true,
    },
    {
        path: 'confirm',
        component: Confirm,
        exact: true,
    },
    {
        path: 'agreement',
        component: Agreement,
        exact: true,
    },
    {
        path: 'auth/iframe',
        component: IframePageCheck,
        exact: true,
    },
    {
        path: 'comp/v1/agreement/origin',
        component: ChangeAgreement,
        exact: true,
    },
    {
        path: 'comp/v1/agreement/new',
        component: ChangeAgreement,
        exact: true,
    },
];
